export const replacePlaceholders = (template: string, replacements: Record<string, string>): string =>
  Object.entries(replacements).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), template)

export function applyPlaceholdersToRecord(
  record: Record<string, string>,
  replacements: Record<string, string>,
  options?: { skipKey?: string }
): Record<string, string> {
  return Object.entries(record).reduce(
    (result, [key, value]) => {
      if (options?.skipKey === key) return result
      result[key] = replacePlaceholders(value, replacements)
      return result
    },
    {} as Record<string, string>
  )
}
